<template>
  <section id="order-bunner">
    <div class="ml-sm-2 mt-4 text-center">
      <img
        class="d-inline-block mb-1 col-8 col-md-2 img"
        :src="bannerSmapleImg"
      />
      <br v-if="isMobile" />
      <img
        class="d-inline-block mb-1 col-8 col-md-2 img"
        :src="bannerSmapleImg"
      />
      <br v-if="isMobile" />
      <img
        class="d-inline-block mb-1 col-8 col-md-2 img"
        :src="bannerSmapleImg"
      />
    </div>
  </section>
</template>
<script>
// import Store from '@/store/index.js'
import Mixin from '@/components/mixin/Mixin' // テーブルレコードの高さ(px)
export default {
  name: 'Banner',
  mixins: [Mixin],
  data: () => ({
    bannerSmapleImg: require('@/assets/img/bnr_sample.jpg'),
  }),
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
#order-bunner
  margin-top: 60px
  @include sp
    margin-top: 30px
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue